const MAIN_ROOT = process.env.REACT_APP_API_URL;
const USERS_API_ROOT = `${MAIN_ROOT}/users`;
const AWS_ROOT = `${MAIN_ROOT}/aws`;

export const BACKEND_ROUTES = {
    /**
     * AWS
     */
    PUBLIC_SIGNED_URL: `${AWS_ROOT}/signed-url`,
    PUBLIC_FILE_LIST: `${AWS_ROOT}/file-list`,

    /**
     * User
     */
    USER: `${USERS_API_ROOT}`,
    MY_INFO: `${USERS_API_ROOT}/my-info`,

    /**
     * Main api
     */
    COMPANY: `${MAIN_ROOT}/companies`,
    CONTRACT: `${MAIN_ROOT}/contracts`,
    PROCESS: `${MAIN_ROOT}/processes`,
    MISSION: `${MAIN_ROOT}/missions`,
    MISSION_FEATURE: `${MAIN_ROOT}/mission-features`,
    MISSION_GEOMETRY: `${MAIN_ROOT}/mission-geometries`,
    MISSION_MODEL: `${MAIN_ROOT}/mission-models`,
    MONTHLY_ACQUISITION: `${MAIN_ROOT}/monthly-acquisitions`,
    REGION: `${MAIN_ROOT}/regions`,
    SEGMENT: `${MAIN_ROOT}/segments`,
    PIPELINE: `${MAIN_ROOT}/pipelines`,
    PIPELINE_INSTANCE: `${MAIN_ROOT}/pipeline-instances`,
    PIPELINE_TEMPLATE: `${MAIN_ROOT}/pipeline-templates`,
    CROP: `${MAIN_ROOT}/crops`,
    SENSOR: `${MAIN_ROOT}/sensors`,
    SYSTEM_MODEL: `${MAIN_ROOT}/system-models`,
    ACQUISITION_VECTOR: `${MAIN_ROOT}/acquisition-vectors`,
    TRAIT: `${MAIN_ROOT}/traits`,
    TRAIT_GROUP: `${MAIN_ROOT}/trait-groups`,
    TRAIT_GROUP_DATA_TYPE: `${MAIN_ROOT}/trait-group-data-types`,
    BBCH_STAGE: `${MAIN_ROOT}/bbch-stages`,
    PLANT_SCALE: `${MAIN_ROOT}/plant-scales`,
    PLANT_PROFILE: `${MAIN_ROOT}/plant-profiles`,
    PRESET: `${MAIN_ROOT}/presets`,
    REFERENCE_OBJECT: `${MAIN_ROOT}/reference-objects`,
    EXPERIMENT: `${MAIN_ROOT}/experiments`,
    EXPERIMENT_MISSION: `${MAIN_ROOT}/experiment-missions`,
    ASSOCIATED_TRAIT_GROUP: `${MAIN_ROOT}/associated-trait-groups`,
    ROLE: `${MAIN_ROOT}/roles`,
    SITE: `${MAIN_ROOT}/sites`,
    USER_ROLE: `${MAIN_ROOT}/user-roles`,
    RAW_DATASET: `${MAIN_ROOT}/raw-datasets`,
    MODULE: `${MAIN_ROOT}/modules`,
    MODULE_VERSION: `${MAIN_ROOT}/module-versions`,
    OUTPUT_BINARY_DATA_SINGLE: `${MAIN_ROOT}/output-binary-data`,
    OUTPUT_BINARY_DATA_LIST: `/output-binary-data`, // processes/{uuid}/output-binary-data or mission-features/{uuid}/output-binary-data
    UPLOAD_TEMPLATES: `${MAIN_ROOT}/upload-templates`,
    MILESTONE: `${MAIN_ROOT}/milestones`,
    STEP: `${MAIN_ROOT}/steps`,
    GEOSERVER_COVERAGE_BOUNDS: `${MAIN_ROOT}/geoserver/coverage-bounds`,
    CROP_MODULE_PRESET: `${MAIN_ROOT}/crop-module-presets`,
    TRAINED_MODEL: `${MAIN_ROOT}/trained-models`,
};
